<template>
  <div>
    <div class="uploader ready">
      <div
        class="upload-drop-site upload-icon"
      >
        <div
          class="handler"
          tabindex="0"
          @click="$refs.fileInput.click()"
        >
          <input
            ref="fileInput"
            accept="image/png,image/jpeg,image/jpg"
            type="file"
            autocomplete="off"
            tabindex="-1"
            style="display: none"
            multiple
            :name="name"
            @input="fileInputFun"
          />
          <!-- <p 
            v-if="errorMsg" 
            ref="errorText" 
            class="text-danger mb-2" 
            tabindex="0"
          >{{ errorMsg }}</p>  -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  checkImageOrFail
} from '@/utils/validation/image'
import VPhotoPreview from './VPhotoPreview'
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import ModalType from '@/utils/dictionaries/modalType'

export default {
  name: 'VPhotoInput',

  components: {
  },

  mixins: [createAuctionManagerMixin()],

  props: {
      name: {
        type: String,
        default: ''
      },
      minCount: {
        type: Number,
        default: 1
      },
      errorMsg: {
        type: String
      },
      onInputFiles: {
        type: Function
      }
      // maxCount: {
      //   type: Number,
      // }
    },

  data: () => ({
    isActiveDragEvent: false,
      photos: [],
      errorList: [],
      allFilesCount: 1,
      morePhotos: 0,
      showError: false,
  }),

  computed: {
  },

  created() {
    if (Array.isArray(this.loadedPhotos)) {
      this.photos = this.loadedPhotos.map(p => ({
          ...p,
          loading: false,
          deleting: false,
          result: { ...p }
      }))
    }
  },

  methods: {
    fileInputFun(e){
      debugger
        this.onInputFiles(e)
        this.$refs.fileInput.value = null;
      },
    hasErrors() {
      this.showError = this.photos.length < this.minCount

      if (this.showError) {
        this.morePhotos = this.minCount - this.photos.length
        this.$nextTick(() => {
          this.$refs.errorText.focus()
        })
      }

      return this.showError
    },

    hasLoadingPhotos() {
      return this.photos.some(p => p.loading)
    },

    setActive() {
      this.isActiveDragEvent = true
    },

    usnetActive() {
      this.isActiveDragEvent = false
    },

    getFileId() {
      this.allFilesCount += 1
      return this.allFilesCount
    },

    async uploadFiles(files) {    
      if (this.disabled) return 
      for (let idx = 0; idx < Array.from(files).length; idx++) {
        try {
          checkImageOrFail(files[idx])
          const newPhoto = {
            id: this.getFileId(),
            file: files[idx],
            loading: true,
            deleting: false,
            result: null
          }
          this.photos.push(newPhoto)

          this[auctionManagerStore.actionTypes.ACTION_ADD_PHOTO_TO_JOINED_CAR]({ idx: newPhoto.id, file: files[idx], name: this.name })
            .then(({ arrId, data }) => {
              const index = this.photos.findIndex(f => f.id === arrId)
              this.photos.splice(index, 1, {
                ...this.photos[index],
                result: data,
                loading: false
              })
            })
            .catch((error) => {
              this.pushError(error.message)
            })

          
        } catch (error) {
          this.pushError(error.message)
        }
      }

      this.hasErrors()
      this.$emit('input', files)
    },

    onDropFiles(e) {
      if (e.dataTransfer.files) {
        this.uploadFiles(e.dataTransfer.files)
      }
    },

    pushError(errorText) {
      this.errorList.push(errorText)

      setTimeout(() => {
        this.removeItemFromArray(this.errorList, errorText)
      }, 5000)
    },

    async removePhoto(photo) {   
      if (this.disabled) return 
      if (!photo.result || !photo.result.id || photo.deleting) return
      const deleting = async () => {
        if (photo.deleting) return
        photo.deleting = true

        try {
          await this[auctionManagerStore.actionTypes.ACTION_REMOVE_CAR_PHOTO]({ imageId: photo.result.id })
        } catch (error) {}

        photo.deleting = false
        this.removeItemFromArray(this.photos, photo, true)

        this.$modals.close(ModalType.ConfirmationModal)
      }

      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: 'Are you sure you want to delete the photo? It will be deleted without saving.',
        buttonText: 'Delete',
        onClickButton: deleting
      })
    },

    removeItemFromArray(array, item, isPhoto) {
      const itemIndex = isPhoto ?
        array.findIndex(_item => _item.id === item.id) :
        array.indexOf(item)

      if (itemIndex >= 0) {
        array.splice(itemIndex, 1)
      }
    },
  }
}
</script>
<style>
.photo-input__remove-btn {
  z-index: 3;
}

.photo-input__remove-btn_deleting::after {
    margin-top: 0 !important;
    background: none !important;
    width: calc(100% - 4px) !important;
    height: calc(100% - 4px) !important;
    border: solid;
    border-radius: 50em;
    border-right: .25em solid white;
    animation: spinner-border .75s linear infinite;
}
</style>
